import React from 'react';
import AboutNav from "./components/Navbar";
import AboutOverview from './components/Overview';
import AboutStruktur from "./components/Struktur";
import AboutDownloads from "./components/Downloads";
import {Routes, Route} from 'react-router-dom';
import './AboutPage.css';

const AboutPage = () => {
    return (
        <div className="about-page">
            <div className='header-banner'>
                <h1>Über RBA</h1>
            </div>
                <div className="about-page__navbar">
                 <AboutNav/>
                </div>
            <div className="about-page__content">
                <Routes>
                    <Route path="/" element={<AboutOverview />} />
                    <Route path="/struktur" element={<AboutStruktur />} />
                    <Route path="/downloads" element={<AboutDownloads />} />
                </Routes>
            </div>
        </div>
    )
}

export default AboutPage;
